import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { words } from 'lodash';
import { StringUtil } from 'utils/StringUtil';
import { Counter } from 'components/atoms/counter';
import { AnnouncementCard } from 'components/molecules/announcementCard';
import { useViewport } from 'components/templates/viewportProvider';
import { HTMLView } from 'components/atoms/htmlView';
import './styles.scss';

const BeliefStatementsMobile = ({ data, theme, cardData, origin }) => {
  const { height } = useViewport();
  let showCounter = origin === 'campaign' ? false : true;
  let card_text = (cardData && cardData.length > 0 && cardData[0].name) || '';
  let card_image =
    (cardData && cardData.length > 0 && cardData[0].posterMobile) || '';

  return (
    <div className={'mobile-section full'}>
      {data.map((data, idx) => {
        const imageUrl = data.image_mobile;
        let description = StringUtil.sliceHtml(data.paragraph);
        return (
          <div className={'section-content row'} key={idx} style={{ height }}>
            <img className={'image-background'} src={imageUrl} alt={'image'} />
            <Row className={'content-row'}>
              <Col xs={{ span: 10 }} sm={{ span: 10 }}>
                <div className={'belief-statement'}>
                  <span>{data.heading}</span>
                  <h2>{data.sub_heading}</h2>
                  {showCounter ? (
                    <p className={'description'}>{description}</p>
                  ) : (
                    <div className={'description'}>
                      <HTMLView
                        className={''}
                        html={data.paragraph}
                        tagName={'p'}
                      />
                    </div>
                  )}
                </div>
              </Col>
            </Row>
            {showCounter && (
              <Counter
                count={idx + 1}
                type={'medium'}
                className={'slide-count'}
              />
            )}
            {/*<AnnouncementCard*/}
            {/*  imageUrl={card_image}*/}
            {/*  title={card_text}*/}
            {/*  onClick={() => {}}*/}
            {/*/>*/}
          </div>
        );
      })}
    </div>
  );
};

export default BeliefStatementsMobile;
